import { httpRequest } from "../../../utils/HttpRequest";
import {
    IKey,
    IMdCmFields,
    IPage,
    ISearchPageField
} from "../../../types/FmsTypes";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";


export interface IMdWarehouseFields extends IMdCmFields {
    code?: string;
    name?: string;
    orgCode?: string;
    orgName?: string;
    contact?: number;
    phone?: string;
    address?: string;
    status?: string;
    note?: string;
}

export type IMdWarehouseDetail = IKey & IMdCmFields & IMdWarehouseFields;
export type IMdWarehouseSearch = IMdWarehouseFields & ISearchPageField;

class WarehouseService {
    async insert(insertVo: IMdWarehouseFields) {
        const apiUrl = "/warehouse/insert";
        return await httpRequest.post<IMdWarehouseDetail>(apiUrl, insertVo);
    }

    async update(updateVo: IMdWarehouseFields) {
        const apiUrl = "/warehouse/update";
        return await httpRequest.post<IMdWarehouseDetail>(apiUrl, updateVo);
    }

    async disable(oneVo: IMdWarehouseFields) {
        const apiUrl = "/warehouse/disable";
        return await httpRequest.post<boolean>(apiUrl, oneVo);
    }

    async find(searchVo: IMdWarehouseFields) {
        const apiUrl = "/warehouse/find";
        return await httpRequest.post<IMdWarehouseDetail[]>(apiUrl, searchVo);
    }

    async warehouseDs(searchVo: IMdWarehouseFields) {
        let { retData } = await this.find(searchVo);
        return retData.map(el => ({
            label: el.name,
            value: el.code
        }));
    }

    async page(searchVo: IMdWarehouseSearch) {
        const apiUrl = "/warehouse/page";
        return await httpRequest.post<IPage<IMdWarehouseDetail>>(apiUrl, searchVo);
    }

    async one(oneVo: IMdWarehouseFields) {
        const apiUrl = "/warehouse/one";
        return await httpRequest.post<IMdWarehouseDetail>(apiUrl, oneVo);
    }

    async sync(syncVo: IMdWarehouseFields) {
        const appPageUrl = "/warehouse/sync";
        syncVo.sourceApp = "fms";
        return await httpRequest.post<boolean>(appPageUrl, syncVo, { timeout: LONG_REQUEST_TIMEOUT });
    }

    async syncPage(searchVo: IMdWarehouseSearch) {
        const appPageUrl = "/warehouse/syncPage";
        searchVo.sourceApp = "fms";
        return await httpRequest.post<boolean>(appPageUrl, searchVo);
    }

    async syncOne(oneVo: IMdWarehouseFields) {
        const appPageUrl = "/warehouse/syncPage";

        return await httpRequest.post<boolean>(appPageUrl, oneVo);
    }
}

export const warehouseService = new WarehouseService();
